@if (visibleProducts$ | async; as visibleProducts) {
  <div class="complementary-product-list">
    <div class="products" #scrollHost>
      @if (fetchProductsLoading) {
        <ng-casto-complementary-product-card [skeleton]="true"></ng-casto-complementary-product-card>
        <ng-casto-complementary-product-card [skeleton]="true"></ng-casto-complementary-product-card>
        <ng-casto-complementary-product-card [skeleton]="true"></ng-casto-complementary-product-card>
        <ng-casto-complementary-product-card [skeleton]="true"></ng-casto-complementary-product-card>
        <ng-casto-complementary-product-card [skeleton]="true"></ng-casto-complementary-product-card>
      } @else {
        @if ((visibleProducts)?.length === 0) {
          <div class="no-product" [innerHTML]="'complementary-products.search.no-product'|translate"></div>
        } @else {
          @for (product of visibleProducts; track product.id) {
            <ng-casto-complementary-product-card [product]="product" [isImageLoaded]="isImageLoaded(product)"
                                                 (onImageLoad)="onImageLoad(product)"
                                                 (onProductQuantityChange)="onProductQuantityChange.emit({
                                                 product: product,
                                                 quantity: $event.quantity
                                               })"
            ></ng-casto-complementary-product-card>
          }

          <div #infiniteSentinel class="infinite-sentinel" aria-hidden="true"></div>
        }
      }
    </div>
  </div>
}
